export const Statuses = {
  DISABLED: 'disabled',
  ACTIVE: 'active',
  UNINSTALLED: 'deleted',
}
